<template>
  <mf-info-card class="mt-4" icon="warning" variant="error" title="Produto não encontrado na base do e-commerce!" :description="infoDescription">
  </mf-info-card>
</template>

<script>
export default {
  name: 'ExternalSyncInfo',
  props: {
    offer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    infoDescription() {
      return `Ao sincronizar a oferta com o e-commerce, este produto com o EAN: ${this.eanText} não foi encontrado na sua base. 
        Para tornar disponível essa oferta do produto, é necessário cadastrar o produto em sua base e reprocessar a campanha aqui pela Mercafacil.`
    },
    eanText() {
      return this.offer.eans.length > 0 ? `${this.offer.eans.join(', ')}` : `${this.offer.ean}`
    },
  },
}
</script>
